import React from "react";
import gras from "../assets/case-studies/gras-cs.png";

export default function AgroCaseStudy() {
  return (
   <div className="cs-pages">
      <img src={gras} alt="Aurelia" width="80%" />
    </div>
  );
}